import React, { useEffect, useState } from "react";
import interactionPlugin from "@fullcalendar/interaction"; // Import interaction plugin
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import "../FullCalendar.css";
import moment from "moment";
import Loader from "../gif/loader.gif";
import { FaChartLine } from "react-icons/fa6";

function CalendarComp() {
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [events, setEvents] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showEventModal, setShowEventModal] = useState(false);
  const [eventModalInfo, setEventModalInfo] = useState({});

  useEffect(() => {
    // Fetch events or load from a source (e.g., API)
    loadEvents();
  }, []);

  const handleDateClick = (info) => {
    const clickedDate = info.dateStr;
    const isEventOnDate = events.some((event) => event.date === clickedDate);

    // If there's no event on the clicked date, handle the empty date click
    if (!isEventOnDate) {
      setSelectedDate(info.dateStr);
      setShowModal(!showModal);
    }
  };
  const handleEventClick = (info) => {
    console.log(info.event);
    setEventModalInfo({
      title: info.event.title,
      date: info.event.date,
      attandance: info.event.attandance,
    });
    setShowEventModal(true);
  };
  const closeEventModal = () => {
    setShowEventModal(false);
  };

  const handleClose = () => setShowModal(false);

  const handleSave = async () => {
    if (new Date(selectedDate) > new Date(eventData.expiryDate)) {
      alert(
        "Expiry date cannot be before start date - Please select expiry after start date"
      );
      return;
    }
    let data = {
      title: eventData.title,
      date: selectedDate,
      expiry: eventData.expiryDate,
    };
    console.log(data);
    try {
      const res = await axios.post(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/save-event`,
        data
      );
      let retcode = res.data.message;
      //stop loading
      setLoading(false);
      alert("Event created..");
    } catch (error) {
      //stop loading
      setLoading(false);
      alert("Failed creating event - try again..");
      console.log("post error =>" + error);
    }
    // You can save event data here or handle state updates to show it on the calendar
    handleClose();
  };
  const buildCalendrEvents = (events) => {
    let newArr = [];
    events.map((item) => {
      newArr.push({
        title: item.event_title,
        attendance: item.attendance,
        date: item.date.split("T")[0],
        display: "background",
        className: "bg-info text-black shadow rounded",
      });
    });
    //console.log(newArr);
    setEvents(newArr);
  };
  const loadEvents = async () => {
    setLoading(!loading);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-getevents`
      );
      let retcode = res.data;
      //console.log(retcode);
      buildCalendrEvents(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get calendar events error =>" + error);
    }
  };

  const renderEventContent = (eventInfo) => {
    const { title, extendedProps } = eventInfo.event;
    const { attendance } = extendedProps; // Access custom field
    const formattedDate = eventInfo.event.start.toLocaleDateString(); // Format event date

    return (
      <div className="text-center mb-3 border">
        <b>
          <small>{title}</small>
        </b>{" "}
        {/* Display title */}
        <small style={{ textTransform: "uppercase", marginTop: -10 }}>
          Attendance: {attendance}
        </small>
        <p style={{ marginTop: -5 }}>
          <i style={{ fontSize: "9pt", fontWeight: "bold" }}>
            click to view report
          </i>
        </p>
      </div>
    );
  };

  return (
    <div>
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        dateClick={handleDateClick}
        editable={true}
        selectable={true}
        height={"500px"}
        events={events}
        eventClick={handleEventClick}
        eventContent={renderEventContent} // Custom render function for event content
        eventColor="#3bc0c3"
        eventTextColor="#000"
        selectAllow={function (selectInfo) {
          return moment().diff(selectInfo.start) <= 0;
        }}
      />

      <Modal
        className="shadow"
        show={showModal}
        onHide={handleClose}
        style={{ borderRadius: 0 }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="h5" style={{ color: "#716caf" }}>
            Add Event
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formEventTitle">
              <Form.Label>
                <small className="text-black">Event Title</small>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter event title"
                value={eventData.title}
                style={{ borderRadius: 0 }}
                onChange={(e) =>
                  setEventData({ ...eventData, title: e.target.value })
                }
              />
            </Form.Group>

            <Form.Group controlId="formStartDate" className="border-0">
              <Form.Label>
                <small className="text-black">Start Date</small>
              </Form.Label>
              <Form.Control type="text" readOnly value={selectedDate} />
            </Form.Group>

            <Form.Group controlId="formExpiryDate">
              <Form.Label>
                <small className="text-black">Expiry Date</small>
              </Form.Label>
              <Form.Control
                type="date"
                value={eventData.expiryDate}
                style={{ borderRadius: 0 }}
                onChange={(e) =>
                  setEventData({
                    ...eventData,
                    expiryDate: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="bg-white text-secondary border-0 bg-secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          {loading ? (
            <img
              src={Loader}
              alt="QR Code"
              width={"100"}
              height={"100"}
              className="img-fluid"
            />
          ) : (
            <Button
              onClick={handleSave}
              style={{
                borderRadius: 0,
                backgroundColor: "#3bc0c3",
                borderWidth: 1,
                borderColor: "#3bc0c3",
              }}
            >
              Save Event
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      {showEventModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Event Recap</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeEventModal}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  <strong>Event name :</strong> {eventModalInfo.title}
                </p>
              </div>
              <div className="modal-footer">
                <Button
                  onClick={handleSave}
                  style={{
                    borderRadius: 0,
                    backgroundColor: "#3bc0c3",
                    borderWidth: 1,
                    borderColor: "#3bc0c3",
                  }}
                >
                  <FaChartLine size={20} className="me-2" />
                  VIEW FULL REPORT
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default CalendarComp;
